//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'
import 'angular-gridster'

//#endregion

import { Activity, Enums } from '../../models/common'
import { OpOperator } from '../../models/core'

import { ConfigHelper, UserSession } from '../../helpers'

import { SERVICES_MODULE_NAME } from './../../services'
import { DEVICE_SERVICE_NAME, DeviceService } from '../../services/device'
import { GridContextMenuService, GRID_CONTEXT_MENU_SERVICE_NAME } from '../../services/grid'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../services/user-session'
import {
	SYSTEM_SERVICE_PROVIDER_NAME,
	SystemServiceProvider,
	$SCOPE_SERVICE_NAME,
	$STATE_SERVICE_NAME,
	$TIMEOUT_SERVICE_NAME,
	SYSTEM_SERVICE_NAME,
	SystemService,
	SYSTEM_CONTEXT_LIST_SERVICE_NAME,
	SystemContextListService,
} from '../../services/system'
import { AddExternalDeviceComponent, COMPONENT_NAME as ADD_EXTERNAL_DEVICE_COMPONENT_NAME } from './custom/add-external-device/add-external-device.component'

import { Api, LocalDictionaryFactory, default as apiModule } from './../api/api.module'
import { DevicesController, DevicesScope } from './devices.controller'
import { DevicesCreateEditDirective } from './create-edit/devices-create-edit.directive'
import { DevicesDetailsDirective } from './details/devices-details.directive'
import { LoggerService, default as commonModule } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

//#region Asset Imports

import * as TEMPLATE from './devices.tpl.html'

//#endregion

// Consts

const CONTROLLER_NAME: string = 'DevicesController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'devicesCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'devicesDetails'
const MENU_INDEX: number = 3
const MODULE_NAME: string = 'simax.devices'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'DEVICE_NAME'
const STATE_NAME: string = 'devices'
const STATE_URL: string = '/devices'

// Consts End

// Setup

const module: ng.IModule = angular.module(MODULE_NAME, [commonModule, apiModule, 'gridster', SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [
	$SCOPE_SERVICE_NAME,
	$STATE_SERVICE_NAME,
	$TIMEOUT_SERVICE_NAME,
	'api',
	'logger',
	'localDictionary',
	USER_SESSION_SERVICE_NAME,
	DEVICE_SERVICE_NAME,
	GRID_CONTEXT_MENU_SERVICE_NAME,
	SYSTEM_SERVICE_NAME,
	(
		$scope: DevicesScope,
		$state: StateService,
		$timeout: ng.ITimeoutService,
		api: Api,
		logger: LoggerService,
		localDictionary: LocalDictionaryFactory,
		userSession: UserSessionService,
		deviceService: DeviceService,
		gridContextMenuService: GridContextMenuService,
		systemService: SystemService
	) =>
		new DevicesController(
			$scope,
			$state,
			$timeout,
			api,
			logger,
			localDictionary,
			userSession,
			deviceService,
			gridContextMenuService,
			systemService,
			DeviceService.REFERENCE_TYPE,
			DeviceService.SIMAX_MODULE_NAME
		),
])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new DevicesDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new DevicesCreateEditDirective()])

module.component(ADD_EXTERNAL_DEVICE_COMPONENT_NAME, new AddExternalDeviceComponent())

module.config([
	'$stateProvider',
	'userSessionProvider',
	SYSTEM_SERVICE_PROVIDER_NAME,
	($stateProvider: StateProvider, userSessionProvider: UserSession, systemServiceProvider: SystemServiceProvider) => {
		systemServiceProvider.registerDetailsComponent({
			key: 'Device_SerialNbr',
			componentName: DETAILS_DIRECTIVE_NAME,
		})

		userSessionProvider.getLoggedOperatorAsync().then((loggedOperator: OpOperator) => {
			if (loggedOperator.hasPermission(Activity.DEVICE_LIST) && !loggedOperator.hasPermission(Activity.DEVICE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DeviceModule)) {
				MenuItem.addMenuItem(ConfigHelper.getIconName(ConfigHelper.Icon.DEVICES), 'devices', MODULE_NAME_LOCALIZATION_TEXT, STATE_NAME, MENU_INDEX)

				$stateProvider.state(STATE_NAME, {
					url: STATE_URL,
					controller: CONTROLLER_NAME,
					template: TEMPLATE,
					params: { ids: null },
				})
			}
		})
	},
])

// Setup End

export default MODULE_NAME
